/* Soap watermark for A Good Bar of Soap.
   A faint marbled swirl behind each interior page title (.page-hero).
   The first time a page is opened in a browser session, one stroke stirs
   through it from left to right, then it stops for good. Later visits in the
   same session show the stirred result as a still image. No mouse or touch
   interaction. Visitors who prefer reduced motion get a still image.
   Needs soap-glass-shaders.js loaded first. */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var KEY = 'agbs-wm:' + location.pathname;

  function css() {
    if (document.getElementById('soap-watermark-css')) return;
    var s = document.createElement('style'); s.id = 'soap-watermark-css';
    s.textContent =
      '.page-hero.has-soap-watermark{position:relative;overflow:hidden}' +
      '.page-hero.has-soap-watermark>*:not(.soap-watermark){position:relative;z-index:1}' +
      '.soap-watermark{position:absolute;inset:0;z-index:0;pointer-events:none;opacity:.10;' +
      'background:center/cover no-repeat;' +
      '-webkit-mask-image:radial-gradient(ellipse at center,#000 30%,transparent 75%);' +
      'mask-image:radial-gradient(ellipse at center,#000 30%,transparent 75%)}' +
      '.soap-watermark canvas{width:100%;height:100%;display:block}';
    document.head.appendChild(s);
  }

  // Each page gets its own spot in the swirl, the same one every visit.
  function seed(path) {
    var h = 2166136261;
    for (var i = 0; i < path.length; i++) { h ^= path.charCodeAt(i); h = Math.imul(h, 16777619) >>> 0; }
    return (h % 100000) / 100000 * 160;
  }
  var rr = function (a, b) { return a + Math.random() * (b - a); };
  var store = {
    get: function () { try { return sessionStorage.getItem(KEY); } catch (e) { return null; } },
    set: function (v) { try { sessionStorage.setItem(KEY, v); } catch (e) { /* storage full or blocked: fine */ } }
  };

  function init(hero) {
    if (hero._wm || !window.SoapGlassShaders) return;
    hero._wm = true;
    css();
    var wrap = document.createElement('div');
    wrap.className = 'soap-watermark'; wrap.setAttribute('aria-hidden', 'true');
    hero.insertBefore(wrap, hero.firstChild);
    hero.classList.add('has-soap-watermark');

    // Already stirred this session: show the saved still.
    var saved = store.get();
    if (saved) { wrap.style.backgroundImage = 'url(' + saved + ')'; return; }

    var box = hero.getBoundingClientRect();
    var ASPECT = Math.max(1.5, Math.min(6, (box.width || 1200) / (box.height || 300)));
    var SW = 640, SH = Math.round(SW / ASPECT);
    var canvas = document.createElement('canvas'); canvas.width = SW; canvas.height = SH;
    wrap.appendChild(canvas);
    var gl = canvas.getContext('webgl', { antialias: false, alpha: false, preserveDrawingBuffer: true });
    if (!gl) { wrap.remove(); hero.classList.remove('has-soap-watermark'); return; }

    var sh = window.SoapGlassShaders(ASPECT, 'classic');
    var FS_COPY = sh.FS_INIT.replace(/uniform float uTime; void main\(\)\{[\s\S]*$/,
      'uniform sampler2D uDye; void main(){ gl_FragColor = vec4(texture2D(uDye, vUv).rgb, 1.); }');

    function compile(fs) {
      var p = gl.createProgram();
      [[gl.VERTEX_SHADER, sh.VS], [gl.FRAGMENT_SHADER, fs]].forEach(function (x) {
        var s = gl.createShader(x[0]); gl.shaderSource(s, x[1]); gl.compileShader(s);
        if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(s));
        gl.attachShader(p, s);
      });
      gl.bindAttribLocation(p, 0, 'a'); gl.linkProgram(p);
      if (!gl.getProgramParameter(p, gl.LINK_STATUS)) throw new Error(gl.getProgramInfoLog(p));
      var u = {}, n = gl.getProgramParameter(p, gl.ACTIVE_UNIFORMS);
      for (var i = 0; i < n; i++) { var name = gl.getActiveUniform(p, i).name; u[name] = gl.getUniformLocation(p, name); }
      return { p: p, u: u };
    }
    function target() {
      var t = gl.createTexture(); gl.bindTexture(gl.TEXTURE_2D, t);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, SW, SH, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
      [gl.TEXTURE_MIN_FILTER, gl.TEXTURE_MAG_FILTER].forEach(function (k) { gl.texParameteri(gl.TEXTURE_2D, k, gl.LINEAR); });
      [gl.TEXTURE_WRAP_S, gl.TEXTURE_WRAP_T].forEach(function (k) { gl.texParameteri(gl.TEXTURE_2D, k, gl.CLAMP_TO_EDGE); });
      var f = gl.createFramebuffer(); gl.bindFramebuffer(gl.FRAMEBUFFER, f);
      gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, t, 0);
      return { t: t, f: f };
    }
    function pair() { var a = target(), b = target(); return { r: function () { return a; }, w: function () { return b; }, swap: function () { var c = a; a = b; b = c; } }; }

    var P, vel, dye;
    try {
      P = { init: compile(sh.FS_INIT), vel: compile(sh.FS_VEL), dye: compile(sh.FS_DYE), copy: compile(FS_COPY) };
      var q = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, q);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
      gl.enableVertexAttribArray(0); gl.vertexAttribPointer(0, 2, gl.FLOAT, false, 0, 0);
      vel = pair(); dye = pair();
    } catch (e) { console.warn('Soap watermark:', e); wrap.remove(); hero.classList.remove('has-soap-watermark'); return; }

    function pass(prog, out, setup) {
      gl.useProgram(prog.p);
      gl.bindFramebuffer(gl.FRAMEBUFFER, out ? out.f : null);
      gl.viewport(0, 0, SW, SH);
      setup(prog.u); gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    }
    function tex(unit, t, loc) { gl.activeTexture(gl.TEXTURE0 + unit); gl.bindTexture(gl.TEXTURE_2D, t); gl.uniform1i(loc, unit); }
    function show() { pass(P.copy, null, function (u) { tex(0, dye.r().t, u.uDye); }); }

    var TIME = seed(location.pathname);
    pass(P.init, dye.r(), function (u) { gl.uniform1f(u.uTime, TIME); });
    [vel.r(), vel.w()].forEach(function (t) { gl.bindFramebuffer(gl.FRAMEBUFFER, t.f); gl.clearColor(128 / 255, 128 / 255, 0, 1); gl.clear(gl.COLOR_BUFFER_BIT); });
    show();

    function finish() {
      show();
      var url = null;
      try { url = canvas.toDataURL('image/jpeg', 0.85); } catch (e) { /* ignore */ }
      if (url) {
        store.set(url);
        // Swap the canvas for a still image, then free the GPU.
        wrap.style.backgroundImage = 'url(' + url + ')';
        canvas.remove();
        var lose = gl.getExtension('WEBGL_lose_context');
        if (lose) lose.loseContext();
      }
    }
    if (reduce) { finish(); return; }

    // One mostly straight stroke, left to right, a little different each time.
    var y0 = rr(.38, .62), tilt = rr(-.10, .10), amp = rr(.05, .09), cyc = rr(1.3, 2.2), ph = rr(0, 6.28);
    var path = function (e) { return [-.05 + 1.1 * e, y0 + tilt * (e - .5) + amp * Math.sin(e * Math.PI * cyc + ph)]; };
    var DUR = rr(1700, 2200), COAST = 900, t0 = 0, last = null, simT = 0, STEP = 1000 / 60;

    // The simulation always advances in 1/60 s steps so the stroke looks the
    // same on fast and slow devices.
    function frame(now) {
      if (!t0) t0 = now;
      var target = now - t0, n = 0;
      while (simT < target && n < 4) { simT += STEP; n++; step(simT); }
      if (n === 4) simT = target; // fell behind: skip ahead rather than lag
      show();
      if (simT < DUR + COAST) requestAnimationFrame(frame); else finish();
    }

    function step(ms) {
      var k = Math.min(ms / DUR, 1);
      var e = k < .5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
      var stirring = k < 1, pos = stirring ? path(e) : null, delta = [0, 0], active = 0;
      if (pos) { if (last) { delta = [pos[0] - last[0], pos[1] - last[1]]; active = 1; } last = pos; }
      pass(P.vel, vel.w(), function (u) {
        tex(0, vel.r().t, u.uVel);
        gl.uniform2f(u.uPos, pos ? pos[0] : -9, pos ? pos[1] : -9);
        gl.uniform2f(u.uDelta, delta[0], delta[1]);
        gl.uniform1f(u.uActive, active); gl.uniform1f(u.uRadius, .085);
      });
      vel.swap();
      pass(P.dye, dye.w(), function (u) {
        tex(0, dye.r().t, u.uDye); tex(1, vel.r().t, u.uVel);
        gl.uniform1f(u.uTime, TIME); gl.uniform1f(u.uRelax, .0006);
        gl.uniform2f(u.uPos, -9, -9); gl.uniform1f(u.uActive, 0);
        gl.uniform3f(u.uInk, 0, 0, 0);
      });
      dye.swap();
    }

    // Start once the title band is on screen, after the page has painted.
    var go = function () { setTimeout(function () { requestAnimationFrame(frame); }, 350); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (es.some(function (x) { return x.isIntersecting; })) { io.disconnect(); go(); }
      }, { threshold: .2 });
      io.observe(hero);
    } else go();
  }

  function boot() {
    document.querySelectorAll('.page-hero').forEach(function (h) {
      try { init(h); } catch (e) { console.warn('Soap watermark:', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
